export * from './otp.component';
